import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Users, Plus, Calendar, MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./NoClub.css";

export default function NoClub() {
    const { t } = useTranslation();

    return (
        <motion.div
            className="no-club-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <div className="icon-container">
                <motion.div
                    className="icon-wrapper"
                    initial={{ rotate: 0, scale: 0.8 }}
                    animate={{ rotate: 12, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <Users className="icon" />
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="text-content"
            >
                <h1 className="title">
                    {t('noClubFound')}
                </h1>
                <p className="description">
                    {t('createFirstClub')}
                </p>
                <Link to="/home/ManageClubs/JoinClub" className="button-link">
                    <button className="no-club-submit-button">
                        {t('joinClub')}
                    </button>
                </Link>
                <Link to="/home/ManageClubs/AddClub" className="button-link">
                    <button className="no-club-submit-button">
                        <Plus className="button-icon" />
                        {t('createClub')}
                    </button>
                </Link>
            </motion.div>

            <motion.div
                className="features-grid"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
            >
                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <Users className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('communityBuilding')}</h3>
                    <p className="feature-description">{t('communityBuildingDesc')}</p>
                </div>

                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <Calendar className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('eventOrganization')}</h3>
                    <p className="feature-description">{t('eventOrganizationDesc')}</p>
                </div>

                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <MessageSquare className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('communityCommunication')}</h3>
                    <p className="feature-description">{t('communityCommunicationDesc')}</p>
                </div>
            </motion.div>
        </motion.div>
    );
}
